import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { AxiosResponse } from 'axios'
import store from 'store'

import _find from "lodash/find"
import trans from "trans"

import {
    Icon,
    Spinner,
    Grid,
    Button,
    Theme,
    css,
    Section,
    modal,
} from "@bdfx/mergado-ui-kit"
import { ItemInterface, ReactSortable } from "react-sortablejs"

import {TextField} from "@mui/material"

import { getTemplateGallery, superadminGetPromoTemplates, superadminSavePromoTemplates } from "app/helpers/api";
import { TemplateGalleryType } from 'template-edit/components/template-gallery';
import PreviewTemplateSVG from 'template-edit/containers/preview-template-svg';
import { AlternativeImage, RandomProduct } from 'shape-edit/types';
import SelectPromoTemplateModalWrapper from './select-promo-template-modal-warpper';
import { createToast } from "actions";
import { textToast } from "app/helpers/toast_factory";

export type PromoTemplate = {
    priority: number
    trans_cz: string
    trans_en: string
    templates: string
    is_remove_background: string
    is_random_color: string
}

interface Props {
}

interface State {
    templateGallery: TemplateGalleryType[]
    promoTemplates: PromoTemplate[]
    isLoadingTemplates: boolean
    isLoadingGallery: boolean
    isSaving: boolean
}

class AuditPromoTemplates extends Component<Props, State> {
    constructor(props) {
        super(props)
        this.state = {
            templateGallery: null,
            promoTemplates: null,
            isLoadingTemplates: null,
            isLoadingGallery: null,
            isSaving: null,
        }
    }

    getPromoTemplates = () => {
        this.setState({ isLoadingTemplates: true })
        superadminGetPromoTemplates()
            .then((response: AxiosResponse<PromoTemplate[]>) => {
                this.setState({ promoTemplates: response.data })
            })
            .catch(e => console.error('cannot get promo images', e.response))
            .finally(() => this.setState({ isLoadingTemplates: false }))
    }

    getGallery = () => {
        this.setState({ isLoadingGallery: true })
        getTemplateGallery(1)
            .then((response: AxiosResponse<TemplateGalleryType[]>) => {
                this.setState({ templateGallery: response.data })
            })
            .catch(e => console.error('cannot get template gallery'))
            .finally(() => this.setState({ isLoadingGallery: false }))
    }

    componentDidMount(): void {
        this.getPromoTemplates()
        this.getGallery()
    }

    saveChangesAndRerender = () => {
        const { promoTemplates } = this.state
        this.setState({ isSaving: true })
        superadminSavePromoTemplates(promoTemplates)
            .then((response: AxiosResponse<any>) => {
                store.dispatch(createToast(textToast('success', 'saved')))
            })
            .catch(e => console.error(e))
            .finally(() => this.setState({ isSaving: false }))
    }

    selectItem = (o: TemplateGalleryType, isBgRemove: boolean, isRandomColors: boolean) => {
        console.log('template selected', o)
    }

    reorder = (list: ItemInterface[]) => {
        const { promoTemplates } = this.state

        if (promoTemplates) {
            const newOrder = list.map(i => i.id)
            const order = promoTemplates.map(promoTemplate => `${promoTemplate.templates}`)

            if (order.join(',') !== newOrder.join(',')) {
                let updatedPromoTemplates = []
                newOrder.forEach((promoTemplateId, key) => {
                    const promoTemplate = _find(promoTemplates, (promoTemplate) => {
                        return promoTemplate.templates === promoTemplateId
                    })
                    updatedPromoTemplates.push({
                        ...promoTemplate,
                        priority: key + 1
                    })
                    this.setState({ promoTemplates: updatedPromoTemplates })
                })
            }
        }
    }

    updatePromoTemplate = (templateId: string, i: number, j: number, isBgRemove: boolean, isRandomColors: boolean) => {
        const { promoTemplates } = this.state

        let updatedPromoTemplates = [...promoTemplates]
        const selectedLine = promoTemplates[i]

        let parsedTemplates = selectedLine.templates.split(',')
        let parsedIsBgRemove = selectedLine.is_remove_background.split(',')
        let parsedIsRandomColor = selectedLine.is_random_color.split(',')

        parsedTemplates[j] = templateId
        parsedIsBgRemove[j] = isBgRemove ? '1' : '0'
        parsedIsRandomColor[j] = isRandomColors ? '1' : '0'

        updatedPromoTemplates[i].templates = parsedTemplates.join(',')
        updatedPromoTemplates[i].is_remove_background = parsedIsBgRemove.join(',')
        updatedPromoTemplates[i].is_random_color = parsedIsRandomColor.join(',')

        this.setState({ promoTemplates: updatedPromoTemplates })
    }

    showSelectModal = (i: number, j: number, group: string) => {
        modal({
            overlayClassName: 'select-promo-template',
            title: `Ukázková šablona pro řádek ${i + 1} sloupec ${j + 1}`,
            message: (close) => <Provider store={store}>
                <SelectPromoTemplateModalWrapper
                    templateGallery={this.state.templateGallery}
                    selectTemplate={this.updatePromoTemplate}
                    i={i}
                    j={j}
                    group={group}
                    close={close}
                />
            </Provider>,
        })
    }

    render() {
        const { templateGallery, promoTemplates, isLoadingGallery, isLoadingTemplates, isSaving } = this.state

        const alternativeImage: AlternativeImage = {
            url: 'https://www.feed-image-editor.com/sites/all/themes/fie/logo.svg',
            w: 365,
            h: 60
        }
        const randomProduct: RandomProduct = {
            id: null,
            serialized_data: [],
            image_id: null,
            isAlt: null,
            image_link: 'https://audit-obrazku.cz/a/ai/demo/4bf07d178bcaf52286073b322deebc52ef15c830748ff2975f25035c27540fdc_orig.jpeg',
            alternative_images: [alternativeImage],
            origWidth: 200,
            origHeight: 200,
            width: 200,
            height: 200,
            image_hash: null,
            isLoading: false,
            isLoaded: true,
            isError: null,
        }

        const randomProductBgRemoved: RandomProduct = {
            id: null,
            serialized_data: [],
            image_id: null,
            isAlt: null,
            image_link: 'https://audit-obrazku.cz/a/ai/demo/4bf07d178bcaf52286073b322deebc52ef15c830748ff2975f25035c27540fdc_bgremoved.png',
            alternative_images: [alternativeImage],
            origWidth: 200,
            origHeight: 200,
            width: 200,
            height: 200,
            image_hash: null,
            isLoading: false,
            isLoaded: true,
            isError: null,
        }

        const list: ItemInterface[] = promoTemplates ? promoTemplates.map(promoTemplate => {
            return {
                id: `${promoTemplate.templates}`,
                selected: false
            }
        }) : []

        return (
            <StyledSection
                prefix={trans('audit_promo_templates')}
                header={isSaving ? <Spinner type='bubbles' /> : ' '}
                suffix={<Grid cols={'1fr 1fr 1fr'} gap={'10px'}>
                    <Button
                        type={'void'}
                        color={Theme.green}
                        icon={<Icon type={'check'} text={trans('save_and_rerender_promo')} />}
                        onClick={(e) => this.saveChangesAndRerender()}
                    />
                    <Button
                        type='void'
                        color={Theme.orange}
                        onClick={(e) => this.getPromoTemplates()}
                        icon={<Icon type={'refresh'} text={trans('reload_saved')} />}
                    />
                    <Button
                        type='void'
                        color={Theme.red}
                        onClick={(e) => this.setState({
                            promoTemplates: [
                                { priority: 1, trans_cz: 'Akce a slevy', trans_en: 'Promotions and discounts', templates: '128,126,124,123', is_remove_background: '1,1,0,1', is_random_color: '0,0,0,0' },
                                { priority: 2, trans_cz: 'Novinky', trans_en: 'New arrival', templates: '149,147,97,148', is_remove_background: '1,0,0,1', is_random_color: '0,0,0,0' },
                                { priority: 3, trans_cz: 'Sezónní kampaně', trans_en: 'Seasonal Campaigns', templates: '188,190,186,157', is_remove_background: '1,0,0,1', is_random_color: '0,0,0,0' },
                                { priority: 4, trans_cz: 'Dárek zdarma', trans_en: 'Free gift', templates: '177,169,153,179', is_remove_background: '1,1,1,0', is_random_color: '0,0,0,0' },
                                { priority: 5, trans_cz: 'Barevné pozadí', trans_en: 'Coloured background', templates: '205,205,205,205', is_remove_background: '1,1,1,1', is_random_color: '1,1,1,1' },
                                { priority: 6, trans_cz: 'Doprava zdarma', trans_en: 'Free delivery', templates: '206,207,208,209', is_remove_background: '0,0,0,0', is_random_color: '0,0,0,0' },
                                { priority: 7, trans_cz: 'Barva roka 2023 - Viva Magenta', trans_en: 'Colour of the Year 2023 - Viva Magenta', templates: '198,197,194,196', is_remove_background: '1,1,0,0', is_random_color: '0,0,0,0' },
                            ]
                        })}
                        icon={<Icon type={'th'} text={trans('back_to_predefined')} />}
                    />
                </Grid>}>

                {promoTemplates &&
                    <React.Fragment>
                        <table className={`${isLoadingTemplates ? 'muk-helper-loading' : ''}`}>
                            <tr>
                                <th>{trans('priority')}</th>
                                <th>cz</th>
                                <th>en</th>
                                <th colSpan={4}>{trans('templates')}</th>
                            </tr>
                            {promoTemplates &&
                                <ReactSortable list={list} setList={this.reorder} handle=".drag-handle" tag="tbody">
                                    {promoTemplates.map((t: PromoTemplate, i: number) =>
                                        <tr key={`t_${t.priority}`}>
                                            <td className='centered nowrap'>
                                                <Icon type={'bars'} size={12} className='drag-handle' color={Theme.steelblue} text={`${t.priority}`} />
                                            </td>
                                            <td>
                                                <TextField
                                                    variant="standard"
                                                    value={t.trans_cz}
                                                    onChange={(e) => {
                                                        const newValue = e.target.value
                                                        let updatedPromoTemplates = [...promoTemplates]
                                                        updatedPromoTemplates[i].trans_cz = newValue
                                                        this.setState({ promoTemplates: updatedPromoTemplates })
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <TextField
                                                    variant="standard"
                                                    value={t.trans_en}
                                                    onChange={(e) => {
                                                        const newValue = e.target.value
                                                        let updatedPromoTemplates = [...promoTemplates]
                                                        updatedPromoTemplates[i].trans_en = newValue
                                                        this.setState({ promoTemplates: updatedPromoTemplates })
                                                    }}
                                                />
                                            </td>
                                            {templateGallery && t.templates.split(',').map((templateId: string, j: number) => {
                                                const template = _find(templateGallery, (g) => g.id === parseInt(`${templateId}`))
                                                const isBgRemove = !!JSON.parse(template.serialized_template).is_remove_background
                                                return <td key={`tid_${t.priority}_${j}`} className={'clickable'} onClick={(e) => this.showSelectModal(i, j, template.groups)} title={`promo_template_${templateId}`}>
                                                    {template &&
                                                        <PreviewTemplateSVG
                                                            templateGallery={template}
                                                            randomProduct={isBgRemove ? randomProductBgRemoved : randomProduct}
                                                            isAlt={false}
                                                        />
                                                    }
                                                </td>
                                            })}
                                        </tr>
                                    )}
                                </ReactSortable>
                            }
                        </table>
                    </React.Fragment>
                }


            </StyledSection>
        )
    }
}

const StyledSection = css(Section)({
    ' .muk-grid.m-header': {
        gridTemplateColumns: 'max-content max-content auto',
    },
    ' .drag-handle': {
        cursor: 'move',
    }
})


export default AuditPromoTemplates